import React from 'react';
import PropTypes from 'prop-types';
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
} from 'react-share';

import Label from '../Label';
import ReferralUrlInput from '../../../apps/pro/views/Welcome/ShutterbugLanding/components/ReferralUrlInput';
import Button from '../Button';

const propTypes = {
  url: PropTypes.string.isRequired,
  content: PropTypes.any,
  hashtag: PropTypes.string,
  onClose: PropTypes.func,
};

const SocialShareUrl = ({ url, content, hashtag = '#waldo', onClose }) => {
  return (
    <div className="social-share-url">
      {content}
      <div>
        <Label for="referral" className="mt-4">
          Your referral link
        </Label>
        <ReferralUrlInput url={url} className="mt-0" />
      </div>
      <div className="d-flex my-2">
        <FacebookShareButton url={url} hashtag={hashtag} className="mr-1">
          <FacebookIcon round size={40} />
        </FacebookShareButton>

        <TwitterShareButton
          url={url}
          hashtags={[hashtag]}
          title="Get your own free account now!"
          via="waldophotos"
        >
          <TwitterIcon round size={40} />
        </TwitterShareButton>
      </div>
      {onClose && (
        <Button
          onClick={() => {
            onClose();
          }}
          btnBlock
          btnStyle="link"
          className="btn-alert-modal-dismiss py-2"
        >
          Dismiss
        </Button>
      )}
    </div>
  );
};

export { SocialShareUrl as SocialShareUrlComponent };

SocialShareUrl.propTypes = propTypes;

export default SocialShareUrl;
